import { render } from "./activity-compose-step4.vue?vue&type=template&id=a3d88e58"
import script from "./activity-compose-step4.vue?vue&type=script&lang=js"
export * from "./activity-compose-step4.vue?vue&type=script&lang=js"

import "./activity-compose-step4.vue?vue&type=style&index=0&id=a3d88e58&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__